import {AngularFireDatabase} from "angularfire2/database";
import {Injectable} from "@angular/core";
import {AngularFirestore} from "angularfire2/firestore";
import {Observable} from "rxjs/Observable";
import {Freelancer} from "./model/freelancer.model";
import * as firebase from 'firebase';
import OrderByDirection = firebase.firestore.OrderByDirection;

@Injectable()
export class FreelancersService {

    constructor(
        private fireDB: AngularFireDatabase,
        private afs: AngularFirestore) {
    }

    addFreelancer(key: string, item: Freelancer) {
        item['created_at'] = new Date().getTime();
        return this.afs.collection<any>('agents').add(JSON.parse(JSON.stringify(item)));
    }

    deleteFreelancer(key: string){
        return this.afs.collection<any>('agents').doc(key).delete();
    }

    updateFreelancer(key: string, item: Freelancer, stringify?: boolean) {
        if(stringify){
            return this.afs.collection('agents').doc(key).update(JSON.parse(JSON.stringify(item)));
        }
        return this.afs.collection('agents').doc(key).update(item);
    }

    getFreelancers(sortBy: string, OrderStatus: OrderByDirection): Observable<any[]> {
        return this.afs.collection('agents', ref => {
            return ref.orderBy(sortBy, OrderStatus);
        }).snapshotChanges();
    }

    searchFreelancers(value: string): Observable<any[]> {
        console.log('executed the query')
        return this.afs.collection('agents', ref => {
            return ref.where('name', '==', value).orderBy('created_at', 'asc');
        }).snapshotChanges();
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/freelancers.service.ts